import '../../utils/context-menu/CreateContextMenus.js'
import 'leaflet-simple-map-screenshoter'
import {map as mapEndpoints } from '../../../../api/api-endpoints.js'
import year from '../../../../utils/year.js'

// слайдер лет для  потоков ..
export const threadsDateSliderMixin = {
  props: {
    years: {
      default: () => ([])
    }
  },
  data() {
    return {
      year: +this.$route?.query?.year || year.getCurrentYear()
    }
  },
  computed: {
    yearList() {
      let data = []
      if (this.years.length) {
        data = this.years
      } else if (this.$store.getters.readUrlEndpoint(this.getYearListEndpoint())) {
        data = this.$store.getters.readUrlEndpoint(this.getYearListEndpoint()).year
      }
      return data.sort((a, b) => +a.year - +b.year).map(i => +i.year || +i)
    },
    min() {
      return this.yearList[0]
    },
    max() {
      return this.yearList.slice(-1)[0]
    },
  },
  methods: {
    getYearListEndpoint() {
      return mapEndpoints.threadsYearDiapasone()
    },
    yearHandler (year) {
      this.replaceRoute({ year }, false)
    },
  },
  created() {
    let promises = []
    if (!this.$store.getters.readUrlEndpoint(this.getYearListEndpoint())?.data) {
      promises.push(this.$store.dispatch('updateUrlEndpoint', {
        endpoint: this.getYearListEndpoint()
      }))
      Promise.all(promises)
    }
  }
}

// слайдер лет для геообъектов ...
export const dateSliderMixin = {
  props: {
    years: {
      default: () => ([])
    },
  },
  data() {
    return {year: 0};
  },
  computed: {
    yearList() {
      let data = []
      if (this.years.length) {
        data = this.years
      } else if (this.$store.getters.readUrlEndpoint(this.getYearListEndpoint())) {
        let endPoint = this.getYearListEndpoint()
        data = this.$store.getters.readUrlEndpoint(endPoint).year
      }
      // выставляем нужный год в самом начале ..
      if (!this.year && data.length > 0) {
        this.year = (+this.$route?.query?.year) || year.getCurrentYear();
      }
      return data.sort((a, b) => +a.year - +b.year).map(i => +i.year || +i)
    },
    min() {
      return this.yearList[0]
    },
    max() {
      return this.yearList.slice(-1)[0]
    },
  },
  methods: {
    getYearListEndpoint() {
      return mapEndpoints.yearListForWasteGeoObjects()
    },
    yearHandler (year) {
      this.replaceRoute({ year }, false)
    },
  },
  created() {
    let promises = []
    if (!this.$store.getters.readUrlEndpoint(this.getYearListEndpoint())?.data) {
      promises.push(this.$store.dispatch('updateUrlEndpoint', {
        endpoint: this.getYearListEndpoint()
      }))
      Promise.all(promises)
    }
  }
}
